import script from "./ClaimsListLegendNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimsListLegendNew.vue?vue&type=script&setup=true&lang=js"

import "./ClaimsListLegendNew.vue?vue&type=style&index=0&id=f84d9420&lang=css"

const __exports__ = script;

export default __exports__